import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { useEffect, useState } from "react"
import apis from "../../api"
import {  getUserSession,  } from "../../Utils/Common"
import { loadCourseCategories } from "../../Component/DataLoader"


const CourseCategorySelector = (props) => {
    const { defaultValue,onChange,courses,name,label} = props
    const [_courses,setCourses] = useState(courses)
    const [error,setError] = useState()
    getUserSession(apis)
    useEffect(()=>{
        if(!_courses) {
           loadCourseCategories(apis,(data)=>{setCourses(data)},setError,1)
        }
    },[])
    return <FormControl fullWidth sx={props.sx}>
        <InputLabel id="demo-simple-select-autowidth-label">{label ?label:"Select course category"} <font color="red">{error}</font></InputLabel>
        <Select labelId="demo-simple-select-autowidth-label" disabled={props.disabled}
            id="product"
            onChange={(e) => { 
                let id = e.target.value; 
                let choice = false
                if(id>0) {
                    for(let i=0;i<_courses.length;i++) {
                        if(id == _courses[i].id) {
                            onChange && onChange(name,_courses[i])
                            choice = true
                            break
                        }
                    }
                }
                if(!choice) {
                    onChange && onChange(name,{id:0})
                }
            }}
            defaultValue={defaultValue}
            label={label ?label:"Select course category"}
        >
            <MenuItem value={0}>Nothing</MenuItem>
            {_courses && _courses.map((p, idx) => {
                return <MenuItem key={idx} value={p.id}>{p.code} | {p.name}</MenuItem>
            })}
        </Select>
    </FormControl>
}
export default CourseCategorySelector